import { render, staticRenderFns } from "./test-guessit.vue?vue&type=template&id=3808856d&scoped=true"
import script from "./test-guessit.vue?vue&type=script&lang=js"
export * from "./test-guessit.vue?vue&type=script&lang=js"
import style0 from "./test-guessit.vue?vue&type=style&index=0&id=3808856d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3808856d",
  null
  
)

export default component.exports